<template>
  <div class="my_container">
    <div class="my_breadcrumb_box">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item v-if="breadcrumb === 'community'" :to="{ name: 'Community' }">社区生态</el-breadcrumb-item>
        <el-breadcrumb-item v-if="breadcrumb === 'union'" :to="{ path: '/union/:id', query: { id: unionId } }">联盟生态</el-breadcrumb-item>
        <el-breadcrumb-item v-if="breadcrumb === 'reaserch'" :to="{ name: 'Reaserch' }">研究院生态</el-breadcrumb-item>
        <el-breadcrumb-item>{{navName}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="title_top_hr">
      <p>
        <i></i>
        <span>{{navName}}</span>
        <el-divider></el-divider>
      </p>
    </div>
    <div class="conciseList_box">
      <div v-if="list.length === 0" class="my_none">暂无数据</div>
      <div v-else v-for="item in list" :key="item.id" class="conciseList_item">
        <div @click="jump(item.list_id, item.nav_id, item.is_doing)">
          <div class="conciseList_item_left">
            <p v-if="item.img !== ''" class="conciseList_item_img">
              <i v-if="item.type === 1 || item.type === 2" class="my_icon_list player_icon"></i>
              <img :src="item.img" alt="封面">
            </p>
            <div :class="item.img === '' ? 'conciseList_item_content conciseList_item_content_pd_left_0' : 'conciseList_item_content'">
              <p class="conciseList_item_title">
                {{item.title}}
              </p>
              <p class="conciseList_item_time">
                {{item.add_time}}
              </p>
            </div>
          </div>
          <div class="conciseList_item_right">
            <button class="my_follow_btn" @click="allJump(item.type, item.list_id, item.nav_id, item.is_doing)">查看</button>
          </div>
        </div>
      </div>
      <page-view v-if="list.length > 0" :list="list" :limit="listPage.limit" @page="page"></page-view>
    </div>
  </div>
</template>

<script>
import page from '../Public/page.vue'
export default {
  components: {
    pageView: page
  },
  data () {
    return {
      navId: '', // 板块id
      navName: '', // 模块名称
      breadcrumb: '', // 面包屑
      unionId: '', // 联盟id
      researchId: '', // 联盟id
      num: 5,
      list: [],
      listPage: {
        page: 1, // 页码
        limit: 10, // 每页条数
        type: '', // 所属板块id
        union_id: '', // 联盟id
        research_id: '' // 研究院id
      }
    }
  },
  created () {
    this.navId = this.$route.query.nav
    const modelName = this.$route.query.type
    this.remakeBreadcrumb(this.navId, modelName)
  },
  methods: {
    remakeBreadcrumb (id, name) {
      switch (id) {
        case '1':
          this.breadcrumb = 'community'
          break
        case '2':
          this.breadcrumb = 'union'
          this.listPage.union_id = this.$route.query.unionId
          this.unionId = this.$route.query.unionId
          break
        case '3':
          this.breadcrumb = 'research'
          this.listPage.research_id = this.$route.query.researchId
          this.researchId = this.$route.query.researchId
          break
      }
      if (name === 'hot') {
        this.navName = '热搜'
      } else if (name === 'recommend') {
        this.navName = '推荐'
      } else {
        this.navName = '动态'
      }
      this.listPage.type = id
      this.getList()
    },
    getList () {
      const vueThat = this
      if (this.navName === '热搜') {
        vueThat.myApi.hotList(vueThat.listPage).then((res) => {
          if (res.data.code === 200) {
            vueThat.list.push(...res.data.data)
          }
        })
      } else if (this.navName === '推荐') {
        vueThat.myApi.recommendList(vueThat.listPage).then((res) => {
          if (res.data.code === 200) {
            vueThat.list.push(...res.data.data)
          }
        })
      } else {
        vueThat.myApi.unionDynamic(vueThat.listPage).then((res) => {
          if (res.data.code === 200) {
            vueThat.list.push(...res.data.data)
          }
        })
      }
    },
    page (num) {
      this.listPage.page = num
      this.getList()
    },
    allJump (type, id, navId, isDoing) {
      this.mycommon.allJump(this, type, id, navId, isDoing)
    }
  }
}
</script>

<style>
</style>
